import { Box, Checkbox, FormControlLabel, FormHelperText } from '@mui/material';

import { type UseToggleFieldProps, useToggleField } from './useToggleField';

export function BlockCheckboxField<TActiveState = boolean, TInactiveState = boolean>(
  props: UseToggleFieldProps<TActiveState, TInactiveState>
) {
  const { controlProps, label, displayedHelperText, isFieldErrorVisible } = useToggleField(props);
  return (
    <Box>
      <FormControlLabel control={<Checkbox {...controlProps} />} label={label} />
      {displayedHelperText && (
        <FormHelperText error={isFieldErrorVisible}>{displayedHelperText}</FormHelperText>
      )}
    </Box>
  );
}
